import React, { Component } from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
import ContentWrapper from "./../../template/Layout/ContentWrapper";
import FlotChart from "./../../template/Common/Flot";
import VectorMap from "../../template/Maps/VectorMap";
import EventsTable from "./components/EventsTable";
import CardsTotals from "./components/CardTotals";
import Chart from "react-google-charts";
import { TableLoader, FullLoader } from "./components/Loader/";
import YearsSelect from "./components/CatYears";
import ClientesList from "../../../services/storageClient.js";
import Loader from "./../../Global/Loader";
import "./styles.scss";
import Axios from "axios";
import { Services } from "./Services";
import img1 from "../../../resources/Pin.png";
import Ship from "../../../resources/Ship.png";
import Aeroplane from "../../../resources/Aeroplane.png";
import Container from "../../../resources/Container.png";

const clientSave = new ClientesList();

const defaultColors = {
  markerColor: "#23b7e5", // the marker points
  bgColor: "transparent", // the background
  scaleColors: ["#878c9a"], // the color of the region in the serie
  regionFill: "#bbbec6", // the base region color
};

const flotOptions = {
  series: {
    lines: {
      show: false,
    },
    points: {
      show: true,
      radius: 4,
    },
    splines: {
      show: true,
      tension: 0.4,
      lineWidth: 1,
      fill: 0.5,
    },
  },
  grid: {
    borderColor: "#eee",
    borderWidth: 1,
    hoverable: true,
    backgroundColor: "#fcfcfc",
  },
  tooltip: true,
  tooltipOpts: {
    content: (label, x, y) => x + " : " + y,
  },
  xaxis: {
    tickColor: "#fcfcfc",
    mode: "categories",
  },
  yaxis: {
    min: 0,
    // max: 10, // optional: use it for a clear represetation
    tickColor: "#eee",
    autoscaleMargin: 0.5,
    //position: 'right' or 'left',
    tickDecimals: 0,
    tickFormatter: (v) => v /* + ' visitors'*/,
  },
  shadowSize: 0,
};

// let orderFillment = {
//   animate: {
//     duration: 800,
//     enabled: true
//   },
//   barColor: '#23b7e5',
//   trackColor: 'rgba(200,200,200,0.4)',
//   scaleColor: false,
//   lineWidth: 10,
//   lineCap: 'round',
//   size: 145
// };

/*=============================================
=            Dashboard Component Functions    =
=============================================*/
// async function calculateSeries(data) {
//   let Series = {};
//   for (let index = 0; index < data.length; index++) {
//     const element = data[index];
//     Series[element.country] = element.value;
//   }
//   return Series;
// }
async function calculateLogistics(data) {
  let Logistics = [
    [
      "Element",
      "Total",
      { role: "style" },
      {
        sourceColumn: 0,
        role: "annotation",
        type: "string",
        calc: "stringify",
      },
    ],
  ];
  for (let index = 0; index < data.length; index++) {
    const element = data[index];
    Logistics.push([
      element.label,
      element.value,
      element.color,
      element.extra,
    ]);
  }
  return Logistics;
}
/*=============================================
=            Dashboard Component              =
=============================================*/
class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totals: "",
      flat: false,
      clientesSelect: clientSave.getAuthentication("client"),
      flotData: [],
      Attention: [],
      Logistics: [],
      Map: [],
      loadingTrends: true,
      loadingTotals: true,
      RegionValues: {},
      fullLoader: false,
    };
  }
  /*=============================================
  =            Get Info Dashboard Function      =
  =============================================*/
  getInfoDashBoard = async () => {
    let data = {
      customer: this.state.clientesSelect,
    };
    let response = await Axios.post(
      `${Services.GET_DASHBOARD_SERVICE.path}dashboard/total`,
      data
    );

    let Logistics = [];
    Logistics = await calculateLogistics(response.data.data.primeChart);
    this.setState({
      totals: response.data.data.totales,
      Logistics,
      flat: response.data.data.primeChart.length <= 0 ? true : false,
      // Map:response.data.data.Mapdata,
      Map: [],
      RegionValues: response.data.data.regionvalue,
      loadingTrends: false,
      fullLoader: true,
    });
  };
  /*=============================================
  =            Life Cicle Component             =
  =============================================*/

  componentDidMount() {
    this.getInfoDashBoard();
    this.containers();
    document.getElementById("body").className = "layout-fixed"; // !changed for nothing
  }

  containers = () => {
    let data2 = {
      cliente: this.state.clientesSelect,
      year: new Date().getFullYear(),
    };

    // console.log('data2---->', data2);
    Axios.post(
      `${Services.GET_DASHBOARD_TOPERACIONES.path}dashboard/Shipment-By-Origin`,
      data2
    )
      .then((response) => {
        const colores = ["#3b87e8", "#005e97"];
        response.data.data.map((array, i) =>
          array.color = colores[i % colores.length]
        )
        this.setState({ flotData: response.data.data });
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  onChangeYear = async (data) => {
    // ? flotData
    let data2 = {
      cliente: this.state.clientesSelect,
      year: data,
    };
    try {
      let TrendShipmentByYear = await Axios.post(
        `${Services.GET_DASHBOARD_TOPERACIONES.path}dashboard/Shipment-By-Origin`,
        data2
      );
      const colores = ["#3b87e8", "#005e97"];
      TrendShipmentByYear.data.data.map((array, i) =>
        array.color = colores[i % colores.length]
      )

      this.setState({ flotData: TrendShipmentByYear.data.data });
    } catch (error) {
      console.error(error);
    }
  };

  /*=============================================
  =            Render Method                    =
  =============================================*/

  render() {
    const {
      totals,
      flotData,
      Logistics,
      Attention,
      Map,
      loadingTrends,
      loadingTotals,
      RegionValues,
      fullLoader,
    } = this.state;
    return (
      <>
        <Loader hidden={fullLoader} />
        <ContentWrapper>
          <Card>
            <CardBody>
              <CardBody>
                <Row>
                  <CardsTotals
                    image={
                      <img
                        src={img1}
                        style={{ width: "4em" }}
                        alt="..."
                      ></img>
                    }
                    // image={<i className="fas fa-map-marker-alt" style={{ fontSize: '-webkit-xxx-large' }} />}
                    xl={3}
                    md={6}
                    loading={loadingTotals}
                    total={totals.T_Shipment ? totals.T_Shipment : "0"}
                    title={"Total Shipments"}
                    propertiesIcon={
                      "col-4 d-flex align-items-center bg-primary-dark justify-content-center rounded-left"
                    }
                    propertiesTitle={"col-8 py-3 bg-primary rounded-right"}
                  />
                  <CardsTotals
                    image={
                      <img
                        src={Ship}
                        style={{ width: "4em" }}
                        alt="..."
                      ></img>
                    }
                    xl={3}
                    md={6}
                    loading={loadingTotals}
                    total={totals.T_Ocean ? totals.T_Ocean : "0"}
                    title={"Active Ocean Shipments"}
                    propertiesIcon={
                      "col-4 d-flex align-items-center bg-purple-dark justify-content-center rounded-left"
                    }
                    propertiesTitle={"col-8 py-3 bg-purple rounded-right"}
                  />
                  <CardsTotals
                    image={
                      <img
                        src={Aeroplane}
                        style={{ width: "4em" }}
                        alt="..."
                      ></img>
                    }
                    xl={3}
                    md={6}
                    loading={loadingTotals}
                    total={totals.T_Air ? totals.T_Air : "0"}
                    title={"Active Air Shipments"}
                    propertiesIcon={
                      "col-4 d-flex align-items-center bg-green-dark justify-content-center rounded-left"
                    }
                    propertiesTitle={"col-8 py-3 bg-green rounded-right"}
                  />
                  <CardsTotals
                    image={
                      <img
                        src={Container}
                        style={{ width: "4em" }}
                        alt="..."
                      ></img>
                    }
                    xl={3}
                    md={6}
                    loading={loadingTotals}
                    total={totals.T_Container ? totals.T_Container : "0"}
                    title={"Active Containers"}
                    propertiesIcon={
                      "col-4 d-flex align-items-center bg-primary-dark justify-content-center rounded-left"
                    }
                    propertiesTitle={"col-8 py-3 bg-primary rounded-right"}
                  />
                </Row>
              </CardBody>
              <br></br>
              <br></br>
              <Row>
                <Col xl={12}>
                  <Row>
                    <Col xs={12} md={6}>
                      <div className="card myCard equalsWidth">
                        <CardBody>
                          <div style={{ fontSize: '1rem' }}>
                            Shipments by Status
                          </div>
                          {loadingTrends ? (
                            <FullLoader />
                          ) : (
                            <Chart
                              width={"100%"}
                              height={"100%"}
                              chartType="BarChart"
                              loader={<div>Loading Chart</div>}
                              data={Logistics}
                              options={{
                                height: 360,
                                // width:
                                bar: { groupWidth: "80%" },
                                legend: { position: "none" },
                                animation: {
                                  startup: true,
                                  easing: "linear",
                                  duration: 1000,
                                },
                              }}
                              rootProps={{ "data-testid": "6" }}
                            />
                          )}
                        </CardBody>
                      </div>
                    </Col>
                    <Col xs={12} md={6}>
                      <div className="card myCard equalsWidth">
                        <div className="card-header">
                          <Col md={12}>
                            <Row>
                              <Col md={8}>
                                <div className="card-title">
                                  {" "}
                                  Trend of Shipments / Containers{" "}
                                </div>
                              </Col>
                              <Col md={4} style={{ textAlign: "right" }}>
                                <YearsSelect
                                  onChangeYear={this.onChangeYear}
                                />
                              </Col>
                            </Row>
                          </Col>
                        </div>
                        <div className="card-body">
                          {loadingTrends ? (
                            <FullLoader />
                          ) : (
                            <FlotChart
                              data={flotData}
                              options={flotOptions}
                            />
                          )}
                        </div>
                      </div>
                    </Col>
                    <Col xl={6}>
                      <Card className="myCard equalsWidth">
                        <div className="card-header">
                          <div className="card-title">
                            {" "}
                            Events that Require Attention{" "}
                          </div>
                        </div>
                        <CardBody>
                          {loadingTrends ? (
                            <TableLoader />
                          ) : (
                            <EventsTable data={Attention} />
                          )}
                        </CardBody>
                      </Card>
                    </Col>
                    {/* <Col xs={12} md={6}>
                        <Card className='myCard'>
                          <CardBody>
                            <h5 className="card-category">Containers by Port</h5>
                            <CardBody>
                              <div className="canvas-container">
                                <Doughnut
                                  data={ContainerDonut.data}
                                  width={60}
                                  height={30}
                                />
                              </div>
                            </CardBody>
                          </CardBody>
                        </Card>
                      </Col> */}
                    <Col xl={6}>
                      <Card className="myCard equalsWidth">
                        <div className="card-header">
                          <div className="card-title">
                            {" "}
                            Shipments By Origin Country
                          </div>
                        </div>
                        <CardBody>
                          {loadingTrends ? (
                            <FullLoader />
                          ) : (
                            <VectorMap
                              options={{
                                map: "world_mill_en",
                                backgroundColor: defaultColors.bgColor,
                                zoomMin: 1,
                                zoomMax: 8,
                                zoomOnScroll: false,
                                regionStyle: {
                                  initial: {
                                    fill: defaultColors.regionFill,
                                    "fill-opacity": 1,
                                    stroke: "none",
                                    "stroke-width": 0,
                                    "stroke-opacity": 1,
                                  },
                                  hover: {
                                    "fill-opacity": 0.8,
                                    cursor: "pointer",
                                  },
                                  //   selected: {
                                  //     fill: 'blue'
                                  //   },
                                  //   selectedHover: {}
                                  // },
                                  // focusOn: {
                                  //   x: 0.4,
                                  //   y: 0.6,
                                  //   scale: 1
                                },
                                markerStyle: {
                                  initial: {
                                    fill: defaultColors.markerColor,
                                    stroke: defaultColors.markerColor,
                                  },
                                },
                                onRegionLabelShow: (e, el, code) => {
                                  if (RegionValues[code])
                                    el.html(
                                      el.html() +
                                      ": " +
                                      RegionValues[code] +
                                      " Sipments"
                                    );
                                },
                              }}
                              series={{
                                regions: [
                                  {
                                    values: RegionValues,
                                    scale: defaultColors.scaleColors,
                                    normalizeFunction: "polynomial",
                                  },
                                ],
                              }}
                              markers={Map}
                            />
                          )}
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </ContentWrapper>
      </>
    );
  }
}

export default Dashboard;
